import React from 'react';
import { Box } from '@material-ui/core';
import { useIntl } from 'umi';

import BaseInformationStyled from './BaseInformationStyled';

const BaseInformation = (props) => {
  //关于国际化
  const { memberDetail } = props;
  const intl = useIntl();
  const { formatMessage } = intl;
  // const location = useLocation();
  // const { query } = location;
  //保持状态
  // const { tab } = query;
  // const { datas } = props;

  const genderObj = {
    F: '女',
    M: '男',
    U: '未知',
  };
  return (
    <BaseInformationStyled>
      <Box className="box">
        <Box className="item">
          <div className="up">
            {formatMessage({ id: 'cm.member.detail.n01.lbl01' })}
          </div>
          <div className="down">{memberDetail?.name}</div>
        </Box>
        <Box className="item">
          <div className="up">
            {formatMessage({ id: 'cm.member.detail.n01.lbl02' })}
          </div>
          <div className="down">{genderObj[memberDetail?.gender]}</div>
        </Box>
        <Box className="item">
          <div className="up">
            {formatMessage({ id: 'cm.member.detail.n01.lbl03' })}
          </div>
          <div className="down">{memberDetail?.memberCode}</div>
        </Box>
        <Box className="item">
          <div className="up">
            {formatMessage({ id: 'cm.member.detail.n01.lbl04' })}
          </div>
          <div className="down"> {memberDetail?.mobile}</div>
        </Box>
        <Box className="item">
          <div className="up">
            {formatMessage({ id: 'cm.member.detail.n01.lbl05' })}
          </div>
          <div className="down"> {memberDetail?.level}</div>
        </Box>
      </Box>
    </BaseInformationStyled>
  );
};
export default BaseInformation;
